import { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileText, Download } from "lucide-react";

export default function Regulasi() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/regulasi").then((r) => setItems(r.data)); }, []);
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Dokumen Resmi</div>
        <h1 className="font-heading font-bold text-3xl lg:text-5xl text-[#003A5C]">Regulasi & Dokumen</h1>
      </div>
      <div className="space-y-3">
        {items.map((r) => (
          <a key={r.id} href={r.url_dokumen} target="_blank" rel="noopener noreferrer"
            className="lift-card flex items-start gap-4 p-5 bg-white rounded-xl border border-slate-100 hover:border-[#00B4D8]">
            <div className="w-12 h-12 rounded-lg bg-[#E1F5FF] grid place-items-center shrink-0">
              <FileText className="w-6 h-6 text-[#005F8E]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-[#003A5C] leading-snug">{r.judul}</div>
              <div className="text-xs text-slate-500 mt-1">{r.jenis} • {r.tahun}</div>
            </div>
            <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-[#003A5C] text-white text-xs font-semibold">
              <Download className="w-3.5 h-3.5" /> PDF
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
